const APIS = {
  DELIVERY_CHARGE: "/logisticservice/api/delivery-charge/",
  MERCHANT: "logisticservice/api/merchant/",
  BRANCH: "/logisticservice/api/branch/",
  USER: "/usermanagementservice/api/user/",
  PRODUCT_TYPE: "logisticservice/api/product-type/",
  SERVICE_TYPE: "/logisticservice/api/service-type/",
  CURRENT_MERCHANT: "/logisticservice/api/merchant/current-merchant-profile/",
  CLIENT_TYPE:"/logisticservice/api/client-type/",
  CARGO_DELIVERY_CHARGE: "/logisticservice/api/delivery-charge/cargo/",

};

export default APIS;
